export const NUMBER = "number"
export const BOOLEAN = "boolean"
export const INTEGER = "integer"
export const INT32 = "int32"
export const INT64 = "int64"
export const STRING = "string"
export const FLOAT = "float"
export const DOUBLE = "double"
export const OBJECT = "object"
export const BYTE = "byte"
export const BINARY = "binary"
export const DATE = "date"
export const DATETIME = "dateTime"
export const ARRAY = "array"
export const HEADER = "header"
export const PASSWORD = "password"
export const APIKEY = "apikey"
export const EMAIL = "email"
